import type { SimState } from './types.ts';

/** FNV-1a 32-bit over a canonical JSON serialisation of the state. */
export function hashString(s: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

export function hashState(state: SimState): string {
  return hashString(JSON.stringify(state));
}
